






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusDeposit extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.process
    }
    switch (this.$props.status) {
      case 'Undeposited':
        return EStatusType.process
      case 'Processed':
        return EStatusType.success
      case 'Pending':
        return EStatusType.pending
      case 'Failed':
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text () {
    let statusTmp = 'Undeposited'
    if (this.$props.status) {
      statusTmp = this.$props.status
    }
    return statusTmp
  }
}
